module.exports = __webpack_public_path__ + "static/media/waterfowl.7d43ac78.webp";